/* eslint-disable react/react-in-jsx-scope */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment';
// AFP-2532 TODO: Fix automatic suppressions below
// https://product-fabric.atlassian.net/browse/AFP-2532
// eslint-disable-next-line @atlassian/tangerine/import/entry-points
import { gridSize, colors } from '@atlaskit/theme';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import Period from './period';
import { PeriodsContainer } from './styled';
import { type RotationProps } from '../../../../common/types';
import { token } from '@atlaskit/tokens';

export function Rotation({ startDate, days, timezone, periods }: RotationProps) {
	return (
		<li
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			className="layer"
			// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
			css={css({
				marginTop: '0px',
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
				lineHeight: `${gridSize() * 2.5}px`,
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
				ol: {
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
					borderBottom: `1px dashed ${token('color.border', colors.N40)}`,
				},
			})}
		>
			<PeriodsContainer>
				{periods.map((props) => (
					<Period
						{...props}
						rotation={{
							startDate,
							days,
							timezone,
						}}
						key={moment(props.startDate).format()}
					/>
				))}
			</PeriodsContainer>
		</li>
	);
}

export default Rotation;
